export default __webpack_public_path__ + "static/ID700-ios-large-3-6d0b4729a9ed468cf322fab8b57da1a1.png";